module.exports = __webpack_public_path__ + "static/media/niina.8f793b20.jpg";